// extracted by mini-css-extract-plugin
export default {"nav":"HeaderNavigation_nav__-vb8F","active":"HeaderNavigation_active__55yil"};